module.exports = __webpack_public_path__ + "static/img/chinaPost.5c444bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/chinaPost.png
// module id = KwVx
// module chunks = 9